export default {
    brandingFeatures: {
        // logo_url: "vendor_prime-logo",
        app_name_prefix: 'PRIME'
    },
    globals: {
        buyRavenUrl: window.location.origin + "/prime/store"
    }
}